import keymirror from "keymirror";
import { IS_PROD } from "./env";

export const TRACKING_API_ENDPOINT = IS_PROD
  ? "https://in-stream.linetv.tw/v1/event"
  : "https://in-stream-dev.linetv.tw/v1/event";

export const TRACKING_API_NAME__LOG_TRACKING = "log_tracking";

export const TRACKING_LOG_VERSION = "1.0.52";

export const TRACKING_OPERATION__SYSCTL = "sysctl";
export const TRACKING_OPERATION__CLICK = "click";

export const TRACKING_EVENT__INIT_SESSION = "init_session";
export const TRACKING_EVENT__PLAY_PLAYER = "play_player";
export const TRACKING_EVENT__PAGE_VIEW = "pageview";
export const TRACKING_EVENT__IMP_PLACEMENT = "imp_placement";
export const TRACKING_EVENT__RECOMMEND_TESTING = "recommend_testing";
export const TRACKING_EVENT__ONCLICK_PLACEMENT = "onclick_placement";
export const TRACKING_EVENT__ONCLICK_BUTTON = "onclick_button";
export const TRACKING_EVENT__IMP = "imp";
export const TRACKING_EVENT__HOVER = "hover";
export const TRACKING_CAMPAIGN_EVENT6 = {
  COMMENT: "comment",
  SCORE: "score",
  KEEP: "keep",
  BEHIND: "behind",
  DRAMA: "drama",
};
export const TRACKING_CLICK_VALUE__SWIPE_LEFT = "swipe_left";
export const TRACKING_CLICK_VALUE__SWIPE_RIGHT = "swipe_right";

export const TRACKING_PAGEVIEW_SOURCE = Object.freeze(
  keymirror({
    SIDEBAR: null,
    NAVBAR: null,

    INDEX_BANNER: null,
    INDEX_ALBUM_ITEM_POSTER: null,
    INDEX_ALBUM_ITEM_COVER_PLAY_DEFAULT: null,
    INDEX_ALBUM_ITEM_COVER_TITLE: null,
    INDEX_CAMPAIGN: null,
    INDEX_CAMPAIGN_MORE: null,
    INDEX_NEWS: null,
    INDEX_NEWS_MORE: null,
    INDEX_CHANNEL_BUTTON: null,
    INDEX_TOP_RANK: null,
    INDEX_WATCH_HISTORY: null,

    DRAMA_EPISODE_MENU_LIST: null,
    DRAMA_EPISODE_MENU_MODULE: null,
    DRAMA_EPISODE_MENU_MOBILE: null,
    DRAMA_AUTO_PLAY_NEXT: null,
    DRAMA_RECOMMEND: null,
    DRAMA_SHARE: null,
    DRAMA_NEED_PACKAGE: null,
    DRAMA_CAMPAIGN: null,

    PURCHASE_CATEGORY_TAB: null,
    PURCHASE_SUBSCRIBE_PACKAGE: null,
    PURCHASE_PAYMENT_RESULT: null,

    USER_MENU: null,
    USER_PAGE_NAV: null,
    USER_WATCH_HISTORY: null,
    USER_FAVORITE_DRAMA: null,

    FEED_TAB_LIST: null,
    FEED_CAMPAIGN: null,
    FEED_NEWS: null,
    FEED_NEWS_DRAMA_RECOMMEND: null,

    SEARCH_RESULT_DROPDOWN: null,
    SEARCH_RESULT_PAGE: null,
    SEARCH_RECOMMENDATION: null,
    SEARCH_RECENTLY: null,
    SEARCH_MORE: null,
    SEARCH_BAR: null,

    CHANNEL_LIST_MENU: null,
    CHANNEL_LIST_TAB: null,
    CHANNEL_HOME_BANNER: null,
    CHANNEL_PREDEFINED_FILTER: null,
    CHANNEL_HOME_ALBUM_ITEM_POSTER: null,
    CHANNEL_HOME_ALBUM_ITEM_COVER_PLAY: null,
    CHANNEL_HOME_ALBUM_ITEM_COVER_TITLE: null,
    CHANNEL_FILTER: null,
    CHANNEL_FILTER_RESULT: null,
    CHANNEL_HOME_CHANNEL_GROUP: null,
    CHANNEL_GROUP_ITEM: null,
  })
);

export const TRACKING_ONCLICK_PLACEMENT = Object.freeze(
  keymirror({
    INDEX_ALBUM_ITEM_COVER_ADD_FAVORITE: null,
    INDEX_ALBUM_ITEM_COVER_REMOVE_FAVORITE: null,
  })
);
